import { Button, Flex } from "@capioweb/ui-components"
import React, { useState } from "react"
import { LocalesContext } from "../../context"
import { FilterItem } from "./FilterItem"

interface ArticlesFilterProps {
	filterItems: string[]
	onFilterItemClicked: (filter: string) => void
	selectedItem: string
}

export const ArticlesFilter: React.FC<ArticlesFilterProps> = ({
	filterItems,
	onFilterItemClicked,
	selectedItem,
}) => {
	const [filterOpen, setFilterOpen] = useState(false)
	const onClick = () => {
		setFilterOpen((f) => !f)
	}
	const { translate, translationKeys } = React.useContext(LocalesContext)

	return (
		<Flex flexDirection={"column"} alignItems={"center"}>
			<div>
				<Button
					textColor={"navy"}
					icon={"filter"}
					onClick={onClick}
					variant="ghost"
				>
					{`${
						filterOpen
							? translate(translationKeys.close)
							: translate(translationKeys.open)
					} ${translate(translationKeys.filter)}`}
				</Button>
			</div>
			{filterOpen ? (
				<Flex py={2.5} flexWrap={"wrap"}>
					{filterItems.map((filterItem, index) => {
						return (
							<Flex
								mt={2}
								mr={index !== filterItems.length - 1 ? 1.5 : 0}
								key={filterItem}
							>
								<FilterItem
									checked={filterItem === selectedItem}
									onClick={onFilterItemClicked}
									description={filterItem}
								/>
							</Flex>
						)
					})}
				</Flex>
			) : (
				<Flex py={2} />
			)}
		</Flex>
	)
}
